import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalWebSocketService {

  private ws: WebSocket | null = null;
  private reconnectTimer: any = null;
  private heartbeatTimer: any = null;

  public sessionId: string;

  constructor() {
    // Garantir que SEMPRE exista um sessionId antes de conectar
    this.sessionId = localStorage.getItem("clientCookieIdentifier")!;
    if (!this.sessionId) {
      this.sessionId = crypto.randomUUID();
      localStorage.setItem("clientCookieIdentifier", this.sessionId);
    }

    this.connect();
  }

  private connect() {
    try {
      console.log("[LocalWS] Connecting to ws://localhost:7056 ...");

      this.ws = new WebSocket("ws://localhost:7056");

      this.ws.onopen = () => {
        console.log("[LocalWS] Connected.");

        this.send({
          Type: "register-session",
          SessionId: this.sessionId
        });

        this.startHeartbeat();
      };

      this.ws.onclose = () => this.scheduleReconnect();
      this.ws.onerror  = () => this.scheduleReconnect();

      this.ws.onmessage = (msg) => {
        console.log("[LocalWS] Message from local server:", msg.data);
      };

    } catch {
      this.scheduleReconnect();
    }
  }

  private scheduleReconnect() {
    if (this.reconnectTimer) return;

    console.log("[LocalWS] Reconnecting in 3s...");

    this.stopHeartbeat();

    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.connect();
    }, 3000);
  }

  private startHeartbeat() {
    this.stopHeartbeat();
    this.heartbeatTimer = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.send({
          Type: "heartbeat",
          SessionId: this.sessionId
        });
      }
    }, 3000);
  }

  private stopHeartbeat() {
    if (this.heartbeatTimer != null) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  public send(obj: any) {
    try {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(obj));
      }
    } catch {}
  }
}
